import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface ActionConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const ActionConfig: React.FC<ActionConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="Általános művelet">
        <ConfigField
          label="Művelet típusa"
          description="Milyen műveletet hajt végre"
        >
          <select
            value={node.data.config?.actionType || 'custom'}
            onChange={(e) => updateConfig('actionType', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="custom">Egyéni művelet</option>
            <option value="log">Naplózás</option>
            <option value="notify">Értesítés</option>
            <option value="calculate">Számítás</option>
            <option value="transform">Átalakítás</option>
          </select>
        </ConfigField>

        <ConfigField
          label="Művelet neve"
          description="A művelet azonosítója"
        >
          <input
            type="text"
            value={node.data.config?.actionName || ''}
            onChange={(e) => updateConfig('actionName', e.target.value)}
            placeholder="my_custom_action"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <ConfigField
          label="Paraméterek (JSON)"
          description="A művelet paraméterei JSON formátumban"
        >
          <textarea
            value={node.data.config?.parameters || '{}'}
            onChange={(e) => updateConfig('parameters', e.target.value)}
            placeholder='{"key": "value"}'
            rows={5}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white font-mono text-sm"
          />
        </ConfigField>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="async"
            checked={node.data.config?.async || false}
            onChange={(e) => updateConfig('async', e.target.checked)}
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
          />
          <label htmlFor="async" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Aszinkron végrehajtás
          </label>
        </div>
      </ConfigSection>

      <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md p-3">
        <div className="text-xs text-gray-600 dark:text-gray-400">
          <strong>ℹ️ Általános művelet:</strong>
          <br />• Egyéni logika implementálásához
          <br />• Változók használhatók a paraméterekben
          <br />• Eredmény: <code>{'{{result}}'}</code>
        </div>
      </div>
    </div>
  );
};

export default ActionConfig;
